module.exports = __webpack_public_path__ + "fonts/fa-regular-400.427d721.woff";